import api from '../../services/api';

// Action Types
export const PAYMENT_MODE_ACTIONS = {
  // Get payment modes
  GET_PAYMENT_MODES_REQUEST: 'GET_PAYMENT_MODES_REQUEST',
  GET_PAYMENT_MODES_SUCCESS: 'GET_PAYMENT_MODES_SUCCESS',
  GET_PAYMENT_MODES_FAILURE: 'GET_PAYMENT_MODES_FAILURE',

  // Get active payment modes
  GET_ACTIVE_PAYMENT_MODES_REQUEST: 'GET_ACTIVE_PAYMENT_MODES_REQUEST',
  GET_ACTIVE_PAYMENT_MODES_SUCCESS: 'GET_ACTIVE_PAYMENT_MODES_SUCCESS',
  GET_ACTIVE_PAYMENT_MODES_FAILURE: 'GET_ACTIVE_PAYMENT_MODES_FAILURE',

  // Get payment mode by ID
  GET_PAYMENT_MODE_BY_ID_REQUEST: 'GET_PAYMENT_MODE_BY_ID_REQUEST',
  GET_PAYMENT_MODE_BY_ID_SUCCESS: 'GET_PAYMENT_MODE_BY_ID_SUCCESS',
  GET_PAYMENT_MODE_BY_ID_FAILURE: 'GET_PAYMENT_MODE_BY_ID_FAILURE',

  // Create payment mode
  CREATE_PAYMENT_MODE_REQUEST: 'CREATE_PAYMENT_MODE_REQUEST',
  CREATE_PAYMENT_MODE_SUCCESS: 'CREATE_PAYMENT_MODE_SUCCESS',
  CREATE_PAYMENT_MODE_FAILURE: 'CREATE_PAYMENT_MODE_FAILURE',

  // Update payment mode
  UPDATE_PAYMENT_MODE_REQUEST: 'UPDATE_PAYMENT_MODE_REQUEST',
  UPDATE_PAYMENT_MODE_SUCCESS: 'UPDATE_PAYMENT_MODE_SUCCESS',
  UPDATE_PAYMENT_MODE_FAILURE: 'UPDATE_PAYMENT_MODE_FAILURE',

  // Delete payment mode
  DELETE_PAYMENT_MODE_REQUEST: 'DELETE_PAYMENT_MODE_REQUEST',
  DELETE_PAYMENT_MODE_SUCCESS: 'DELETE_PAYMENT_MODE_SUCCESS',
  DELETE_PAYMENT_MODE_FAILURE: 'DELETE_PAYMENT_MODE_FAILURE',

  // Toggle payment mode status
  TOGGLE_PAYMENT_MODE_STATUS_REQUEST: 'TOGGLE_PAYMENT_MODE_STATUS_REQUEST',
  TOGGLE_PAYMENT_MODE_STATUS_SUCCESS: 'TOGGLE_PAYMENT_MODE_STATUS_SUCCESS',
  TOGGLE_PAYMENT_MODE_STATUS_FAILURE: 'TOGGLE_PAYMENT_MODE_STATUS_FAILURE',

  // Clear errors
  CLEAR_PAYMENT_MODE_ERRORS: 'CLEAR_PAYMENT_MODE_ERRORS',
};

// Action Creators

// Get all payment modes with pagination and search
export const getPaymentModes = (params = {}) => async (dispatch) => {
  try {
    dispatch({ type: PAYMENT_MODE_ACTIONS.GET_PAYMENT_MODES_REQUEST });

    const response = await api.get('/payment-modes', { params });
    
    dispatch({
      type: PAYMENT_MODE_ACTIONS.GET_PAYMENT_MODES_SUCCESS,
      payload: response.data
    });

    return { success: true, data: response.data };
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Failed to fetch payment modes';
    
    dispatch({
      type: PAYMENT_MODE_ACTIONS.GET_PAYMENT_MODES_FAILURE,
      payload: errorMessage
    });

    return { success: false, message: errorMessage };
  }
};

// Get active payment modes for billing
export const getActivePaymentModes = () => async (dispatch) => {
  try {
    dispatch({ type: PAYMENT_MODE_ACTIONS.GET_ACTIVE_PAYMENT_MODES_REQUEST });

    const response = await api.get('/payment-modes/active');
    
    dispatch({
      type: PAYMENT_MODE_ACTIONS.GET_ACTIVE_PAYMENT_MODES_SUCCESS,
      payload: response.data
    });

    return { success: true, data: response.data };
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Failed to fetch active payment modes';
    
    dispatch({
      type: PAYMENT_MODE_ACTIONS.GET_ACTIVE_PAYMENT_MODES_FAILURE,
      payload: errorMessage
    });

    return { success: false, message: errorMessage };
  }
};

// Get payment mode by ID
export const getPaymentModeById = (id) => async (dispatch) => {
  try {
    dispatch({ type: PAYMENT_MODE_ACTIONS.GET_PAYMENT_MODE_BY_ID_REQUEST });

    const response = await api.get(`/payment-modes/${id}`);
    
    dispatch({
      type: PAYMENT_MODE_ACTIONS.GET_PAYMENT_MODE_BY_ID_SUCCESS,
      payload: response.data
    });

    return { success: true, data: response.data };
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Failed to fetch payment mode';
    
    dispatch({
      type: PAYMENT_MODE_ACTIONS.GET_PAYMENT_MODE_BY_ID_FAILURE,
      payload: errorMessage
    });

    return { success: false, message: errorMessage };
  }
};

// Create payment mode
export const createPaymentMode = (paymentModeData) => async (dispatch) => {
  try {
    dispatch({ type: PAYMENT_MODE_ACTIONS.CREATE_PAYMENT_MODE_REQUEST });

    const response = await api.post('/payment-modes', paymentModeData);
    
    dispatch({
      type: PAYMENT_MODE_ACTIONS.CREATE_PAYMENT_MODE_SUCCESS,
      payload: response.data
    });

    return { success: true, data: response.data };
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Failed to create payment mode';
    
    dispatch({
      type: PAYMENT_MODE_ACTIONS.CREATE_PAYMENT_MODE_FAILURE,
      payload: errorMessage
    });

    return { success: false, message: errorMessage };
  }
};

// Update payment mode
export const updatePaymentMode = (id, paymentModeData) => async (dispatch) => {
  try {
    dispatch({ type: PAYMENT_MODE_ACTIONS.UPDATE_PAYMENT_MODE_REQUEST });

    const response = await api.put(`/payment-modes/${id}`, paymentModeData);
    
    dispatch({
      type: PAYMENT_MODE_ACTIONS.UPDATE_PAYMENT_MODE_SUCCESS,
      payload: response.data
    });

    return { success: true, data: response.data };
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Failed to update payment mode';
    
    dispatch({
      type: PAYMENT_MODE_ACTIONS.UPDATE_PAYMENT_MODE_FAILURE,
      payload: errorMessage
    });

    return { success: false, message: errorMessage };
  }
};

// Delete payment mode
export const deletePaymentMode = (id) => async (dispatch) => {
  try {
    dispatch({ type: PAYMENT_MODE_ACTIONS.DELETE_PAYMENT_MODE_REQUEST });

    const response = await api.delete(`/payment-modes/${id}`);
    
    dispatch({
      type: PAYMENT_MODE_ACTIONS.DELETE_PAYMENT_MODE_SUCCESS,
      payload: id
    });

    return { success: true, data: response.data };
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Failed to delete payment mode';
    
    dispatch({
      type: PAYMENT_MODE_ACTIONS.DELETE_PAYMENT_MODE_FAILURE,
      payload: errorMessage
    });

    return { success: false, message: errorMessage };
  }
};

// Toggle payment mode status
export const togglePaymentModeStatus = (id) => async (dispatch) => {
  try {
    dispatch({ type: PAYMENT_MODE_ACTIONS.TOGGLE_PAYMENT_MODE_STATUS_REQUEST });

    const response = await api.patch(`/payment-modes/${id}/toggle`);
    
    dispatch({
      type: PAYMENT_MODE_ACTIONS.TOGGLE_PAYMENT_MODE_STATUS_SUCCESS,
      payload: response.data
    });

    return { success: true, data: response.data };
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Failed to toggle payment mode status';
    
    dispatch({
      type: PAYMENT_MODE_ACTIONS.TOGGLE_PAYMENT_MODE_STATUS_FAILURE,
      payload: errorMessage
    });

    return { success: false, message: errorMessage };
  }
};

// Clear errors
export const clearPaymentModeErrors = () => (dispatch) => {
  dispatch({ type: PAYMENT_MODE_ACTIONS.CLEAR_PAYMENT_MODE_ERRORS });
};
